
import React, { useEffect, useRef } from 'react';

const CustomRedFlagImage = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  
  useEffect(() => {
    const renderCustomFlag = () => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      
      // Clear canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // Set white background
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // Set flag pole
      ctx.beginPath();
      ctx.moveTo(100, 50);
      ctx.lineTo(100, 250);
      ctx.lineWidth = 8;
      ctx.strokeStyle = '#333';
      ctx.stroke();
      
      // Set flag shape
      ctx.beginPath();
      ctx.moveTo(100, 50);
      ctx.quadraticCurveTo(175, 75, 220, 60);
      ctx.lineTo(220, 130);
      ctx.quadraticCurveTo(175, 145, 100, 120);
      ctx.closePath();
      
      // Fill flag with RedFlags red
      ctx.fillStyle = '#FF3B30';
      ctx.fill();
      
      // Generate download link
      const downloadLink = document.getElementById('download-custom-flag') as HTMLAnchorElement;
      if (downloadLink) {
        downloadLink.href = canvas.toDataURL('image/jpeg', 0.9);
        downloadLink.download = 'custom-redflag-300x300.jpg';
        downloadLink.style.display = 'inline-block';
      }
    };
    
    renderCustomFlag();
  }, []);
  
  return (
    <div className="flex flex-col items-center gap-4 p-6 border rounded-md mt-8">
      <h3 className="text-xl font-bold">Custom Red Flag</h3>
      <canvas 
        ref={canvasRef} 
        width={300} 
        height={300} 
        className="border rounded-md shadow-sm"
      />
      <div className="flex gap-2">
        <a 
          id="download-custom-flag" 
          href="#" 
          className="bg-redflags-red text-white px-4 py-2 rounded-md hover:bg-redflags-red/90 inline-flex items-center"
          style={{ display: 'none' }}
        >
          Download JPG (300x300)
        </a>
      </div>
      <div className="text-sm text-redflags-gray mt-2">
        This is a custom-designed red flag that matches your brand style, created as a JPG image.
      </div>
    </div>
  );
};

export default CustomRedFlagImage;
